export default __webpack_public_path__ + "static/media/2021 Annual Corporate Governance Report (ACGR) Scorecard.1121b6e8.pdf";